import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import InputField from 'components/pure/utils/form/InputField';
import ToggleField from 'components/pure/utils/form/ToggleField';
import './ScorecardReasonForm.styl';
import CardReasonSchemeEntryFormTable from './CardReasonSchemeEntryFormTable';
import SelectField from 'components/pure/utils/form/SelectField';
import CardReasonEditActions from 'actions/CardReasonEditActions';
import {namingSchemas} from 'components/pure/admin/NamingSchemas';

const required = ['name'];

export default class CardReasonSchemeForm extends React.PureComponent {
  componentDidMount() {
    if (this.props.allowChoosingReasonScheme) {
      CardReasonEditActions.initNewFormForScoringScheme(namingSchemas[0].value);
    }
  }

  getError(property) {
    const {cardReasonScheme} = this.props;

    if (property === 'name' && this.props.schemeWithNameExists) {
      return 'There is a scheme with this name.';
    }

    return required.indexOf(property) > -1 &&
      (cardReasonScheme[property] || '').toString().trim() === ''
      ? 'This field is required'
      : null;
  }

  onChange(field, value) {
    this.props.onChange(this.props.cardReasonScheme.set(field, value));
  }

  render() {
    const {cardReasonScheme, allowChoosingReasonScheme} = this.props;

    return (
      <form className="scorecard-reason-form ev-form">
        <FieldContainer
          label="Preset Score Reason Scheme Name"
          errorOnBlur={true}
          error={this.getError('name')}>
          <InputField
            value={cardReasonScheme.name || ''}
            placeholder="Score Reason Scheme Name"
            focused={true}
            onChange={value => this.onChange('name', value)}
            maxLength={25}
          />
        </FieldContainer>
        {allowChoosingReasonScheme && (
          <FieldContainer
            label="Applicable Scorecard Scale"
            errorOnBlur={true}
            error={this.getError('scoringScheme')}>
            <SelectField
              disabled={false}
              value={cardReasonScheme.scoringScheme}
              options={namingSchemas}
              hideResetButton={true}
              onChange={value => {
                CardReasonEditActions.initNewFormForScoringScheme(value);
                this.onChange('scoringScheme', value);
              }}
            />
          </FieldContainer>
        )}
        <p>
          By setting up preset reasons with each score below, you can cause a picklist with those
          reasons to be presented to user when they choose that score for a scorecard question.
        </p>
        <p>
          Using Coach's API, you can then retrieve the selected reasons along with scorecard
          answers, and use these as a part of your analytics.
        </p>

        <CardReasonSchemeEntryFormTable
          scoringScheme={cardReasonScheme.scoringScheme}
          entries={cardReasonScheme.entries}
          onChange={entries => this.onChange('entries', entries)}
        />

        <ToggleField
          className="is_optional"
          onToggle={(_, val) => this.onChange('optional', !val)}
          toggled={!cardReasonScheme.optional}
          label="Require a reason to be selected when applicable. If not selected, users can decide whether or not to choose a reason, when applicable."
        />
      </form>
    );
  }
}
